import { render, staticRenderFns } from "./ExportDetailsDialog.vue?vue&type=template&id=2968f9e2&scoped=true&"
import script from "./ExportDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./ExportDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968f9e2",
  null
  
)

export default component.exports